export default __webpack_public_path__ + "assets/logo-temp.3f73ed.jpg";